import { Bbox } from 'ais-facade-api/api';

export function getBboxObjectDeckGl(bbox: any, zoom: number): Bbox | undefined {
  if (bbox.some((coord: any) => typeof coord !== 'number' || Number.isNaN(coord))) {
    return;
  }
  return {
    first: {
      latitude: bbox[1],
      longitude: bbox[0],
    },
    second: {
      latitude: bbox[3],
      longitude: bbox[2],
    },
    z: zoom,
  };
}
